
import interceptorsModule from '@/config/interceptors'
export const omsStore = {
  namespaced: true,
  state: {
    listOtherComponent: null,
    listCCData: null,
    // SN_CODE
    snCodeDrawer: null,
    // PS_C_PRO
    PS_C_PRO_LOG_DATA: '',
    PS_C_PRO_SN_CUSTOM_TABLE_DATA: [],
    // 特殊日期
    orderSpecialDateRow: {},
    orderSpecialDateShow: false,
    // 接单/营业时间
    orderReceivingRow: {},
    orderReceivingTimeShow: false,
    // drawer1
    isDrawerForPsCProEname: false,
    objectTableItem: 1,
    omsAllOptions: {},
    permissionConds: {},
    addSKU: {}
  },
  mutations: {
    setAddSKU(state, n) {
      state.addSKU = n
    },
    up_permissionConds(state, n) {
      console.log('up_permissionConds', state, n)
      n.data = interceptorsModule.permission.definedVal(n.data)
      if (state.permissionConds.hasOwnProperty([n.tableName])) {
        if (n.isId) {
          state.permissionConds[n.tableName] = state.permissionConds[n.tableName].concat(n.data)
        } else if (n.isDel) {
          // 移除选中行/移除全部
          if (Array.isArray(n.data)) {
            if (n.data.length) {
              state.permissionConds[n.tableName] = state.permissionConds[n.tableName].filter((i, index) => !n.data.includes(index))
            } else {
              state.permissionConds[n.tableName] = []
            }
          }
        } else {
          state.permissionConds[n.tableName].push(n.data)
        }
      } else {
        state.permissionConds[n.tableName] = []
        if (n.isInit) {
          state.permissionConds[n.tableName] = n.data
        } else {
          state.permissionConds[n.tableName].push(n.data)
        }
      }
    },
    up_listCCData(state, n) {
      state.listCCData = n
    },
    up_listOtherComponent(state, n) {
      state.listOtherComponent = n
    },
    up_snCodeDrawer(state, n) {
      state.snCodeDrawer = n
    },
    up_PS_C_PRO_LOG_DATA(state, n) {
      state.PS_C_PRO_LOG_DATA = n
    },
    up_PS_C_PRO_SN_CUSTOM_TABLE_DATA (state, n) {
      state.PS_C_PRO_SN_CUSTOM_TABLE_DATA = n
    },
    upOrderSpecialDateRow(state, n) {
      state.orderSpecialDateRow = n
    },
    upOrderSpecialDateShow(state, n) {
      state.orderSpecialDateShow = n
    },
    upOrderReceivingRow(state, n) {
      state.orderReceivingRow = n
    },
    upOrderReceivingTimeShow(state, n) {
      state.orderReceivingTimeShow = n
    },
    upDrawerForPsCProEname(state, n) {
      state.isDrawerForPsCProEname = n
    },
    upAllOptions(state, n) {
      let obj = _.cloneDeep(state.omsAllOptions)
      let keys = Object.keys(n);
      keys.forEach((k) => obj[k] = n[k]);
      state.omsAllOptions = obj;
    }
  },
  actions: {
    /**
     * 获取控件对应下拉选项值
     * @param {*} param0
     * @param {*} param1
     * eg. getSelectOption({ tableName: 'OC_B_ORDER', parentColName: '基本信息', childColName: ['PAY_TYPE'] })
     */
    async getSelectOption({ state, commit }, { tableName, parentColName, childColName }) {
      const self = vm;
      const fromdata = new FormData();
      fromdata.append('table', tableName);
      fromdata.append('objid', -1);
      const res = await self.service.common.getObject(fromdata);
      const forms = res.data.data.addcolums;
      let selectData = {}
      forms.forEach(item => {
        if (item.parentdesc === parentColName) {
          const childItem = item.childs;
          childItem.forEach(item => {
            if (childColName.includes(item.colname)) {
              item.combobox.forEach(i => {
                i.label = i.limitdesc
                i.value = i.limitval
              })
              selectData[item.colname] = item.combobox;
            }
          });
        }
      });
      return selectData
    },
  }
};
export default omsStore;
